import React, { lazy, Suspense } from 'react'
import { PartnerAccountDataProvider } from '../PartnerAccountDataProvider/PartnerAccountDataProvider'
import { useParams } from 'react-router-dom'
import ResaleCppoFormDetails from '../ResaleCppoFormDetails/ResaleCppoFormDetails'
import { useSyncCloudMarketplace } from '@labrav/common'
import { CombinedFormAzureWrapper } from '../CombinedFormAzureWrapper/CombinedFormAzureWrapper'

const CloudAccountContent = lazy(() =>
  import('../../components/FlyoutSettings').then(module => ({
    default: module.FlyoutCloudAccountWrapper,
  }))
)
const FlyOutCloudSettingsUmbrellaWrapper = lazy(() =>
  import('../../components/FlyoutCloudSettingsWrapper').then(module => ({
    default: module.FlyOutCloudSettingsUmbrellaWrapper,
  }))
)

export { DetailsView } from './DetailsView'

export const InPartnerCloudAccountWrapper: React.FC = () => {
  return (
    <PartnerAccountDataProvider isExternal={true}>
      <Suspense fallback={<div>Loading...</div>}>
        <CloudAccountContent isExternal={true} />
      </Suspense>
    </PartnerAccountDataProvider>
  )
}

export const InPartnerFlyOutCloudSettingsUmbrellaWrapper: React.FC = () => {
  return (
    <PartnerAccountDataProvider isExternal={true}>
      <Suspense fallback={<div>Loading...</div>}>
        <FlyOutCloudSettingsUmbrellaWrapper />
      </Suspense>
    </PartnerAccountDataProvider>
  )
}
export const CombinedFormWrapper: React.FC = () => {
  const { cloud, labraFormId } = useParams<{
    cloud: string
    labraFormId: string
  }>()

  // Sync Redux cloud marketplace state with useCloud value from URL
  useSyncCloudMarketplace()

  return (
    <PartnerAccountDataProvider isExternal={true}>
      <Suspense fallback={<div>Loading...</div>}>
        {cloud === 'aws' && (
          <ResaleCppoFormDetails
            cloud={cloud}
            labraFormId={labraFormId as string}
          />
        )}
        {cloud === 'azure' && <CombinedFormAzureWrapper />}
      </Suspense>
    </PartnerAccountDataProvider>
  )
}
